/** Google Fonts URL for report-builder Poppins Bold and Yantramanav Light. */
export const POPPINS_YANTRAMANAV_GOOGLE_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Poppins:wght@700&family=Yantramanav:wght@300&display=swap";

export const POPPINS_BOLD_FONT_CLASS = "font-poppins-bold";
export const YANTRAMANAV_LIGHT_FONT_CLASS = "font-yantramanav-light";
